/**
 * "Session Timeout" dialog — the last minute before the idle logout. The
 * countdown is fed by the idle hook (time left until the timeout), so it
 * stays right across tabs and after a throttled background tab wakes up.
 * Backdrop and ESC are inert: the user picks Stay logged in or Log out.
 */
import { useSelector } from 'react-redux';
import { Button, Dialog } from '@shared/ui';
import {
  DialogHeader,
  DialogIconBadge,
  DialogTitleBlock,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogFooterStepText,
  DialogFooterActions,
} from '@shared/ui/DialogShell';
import { getTransitionWithVariable } from 'redux_store';

// Timer icon for the dialog's icon-badge. Inlined (there is no clock in
// @shared/ui/icons) so the dialog stays self-contained.
const ClockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </svg>
);

const IdleDialog = ({ open, seconds, onStay, onLogout }) => {
  const { btn, dialogs } = useSelector(state => state.i18n);

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth={440}
      ariaLabel={dialogs.sessionTimeout}
      header={
        <DialogHeader>
          <DialogIconBadge>
            <ClockIcon />
          </DialogIconBadge>
          <DialogTitleBlock>
            <DialogTitle>{dialogs.sessionTimeout}</DialogTitle>
            <DialogDescription>{dialogs.inactivityWarning}</DialogDescription>
          </DialogTitleBlock>
        </DialogHeader>
      }
      footer={
        <DialogFooter>
          <DialogFooterStepText>
            {getTransitionWithVariable(dialogs.autoLogoutIn, { seconds })}
          </DialogFooterStepText>
          <DialogFooterActions>
            <Button variant="ghost" onClick={onLogout}>
              {btn.logOut}
            </Button>
            <Button variant="primary" onClick={onStay}>
              {btn.stayLoggedIn}
            </Button>
          </DialogFooterActions>
        </DialogFooter>
      }
    />
  );
};

export default IdleDialog;
